export const languageLevels: string[] = [
  'English (Default)',
  'German',
  'Spanish',
  'French',
  'Portuguese (Brazilian)',
  'Japanese',
  'Italian',
  'Polish',
  'Russian',
  'Chinese (Simplified)'
];
